import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare } from "lucide-react";

export function TaskQuickProgressDialog({
  isQuickProgressOpen, setIsQuickProgressOpen,
  quickProgressTaskId, setQuickProgressTaskId,
  quickProgressNote, setQuickProgressNote,
  quickProgressMutation, tasks,
}: any) {
  return (
      <Dialog open={isQuickProgressOpen} onOpenChange={setIsQuickProgressOpen}>
        <DialogContent className="w-screen h-screen m-0 rounded-none overflow-y-auto" data-testid="dialog-quick-progress">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="h-5 w-5" />
              Quick Progress Entry
            </DialogTitle>
            <DialogDescription>
              Add a quick progress note to any active task
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">Select Task</label>
              <Select
                value={quickProgressTaskId}
                onValueChange={setQuickProgressTaskId}
              >
                <SelectTrigger data-testid="select-quick-progress-task">
                  <SelectValue placeholder="Choose a task..." />
                </SelectTrigger>
                <SelectContent>
                  {tasks.filter((t: any) => !t.completed).map((task: any) => (
                    <SelectItem key={task.id} value={task.id}>{task.title}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">Progress Notes</label>
              <Textarea
                placeholder="Enter your progress notes..."
                value={quickProgressNote}
                onChange={(e) => setQuickProgressNote(e.target.value)}
                className="min-h-[100px]"
                data-testid="textarea-quick-progress-notes"
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                setIsQuickProgressOpen(false);
                setQuickProgressTaskId("");
                setQuickProgressNote("");
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (quickProgressTaskId && quickProgressNote.trim()) {
                  quickProgressMutation.mutate({
                    taskId: quickProgressTaskId,
                    notes: quickProgressNote.trim(),
                  });
                }
              }}
              disabled={!quickProgressTaskId || !quickProgressNote.trim() || quickProgressMutation.isPending}
              data-testid="button-submit-quick-progress"
            >
              {quickProgressMutation.isPending ? "Saving..." : "Add Progress"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
}
